package com.damda.design_system.ui.viewmodels

import androidx.compose.runtime.State
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.setValue
import com.damda.design_system.core.Event
import com.damda.design_system.ui.views.lists.FoodItem

class FoodCartState {
    var cartItems by mutableStateOf(mapOf<FoodItem, Int>())
        private set

    var cartCount by mutableStateOf(0)
        private set

    private val _onEmptyCartEvent = mutableStateOf(Event(false))
    val onEmptyCartEvent: State<Event<Boolean>> get() = _onEmptyCartEvent


    private val _onAddCartEvent = mutableStateOf(Event(false))
    val onAddCartEvent: State<Event<Boolean>> get() = _onAddCartEvent

    private val _onNotPhoneDialogEvent = mutableStateOf(Event(false))
    val onNotPhoneDialogEvent: State<Event<Boolean>> get() = _onNotPhoneDialogEvent

    private fun updateCartCount() {
        cartCount = cartItems.values.sum()
    }

    fun addToCart(item: FoodItem) {
        val currentCount = cartItems[item] ?: 0
        cartItems = cartItems + (item to currentCount + 1)
        updateCartCount()
        _onAddCartEvent.value = Event(true)
    }

    fun removeFromCart(item: FoodItem) {
        val currentCount = cartItems[item] ?: return
        cartItems = if (currentCount > 1) {
            cartItems + (item to currentCount - 1)
        } else {
            _onEmptyCartEvent.value = Event(true)
            cartItems - item
        }

        updateCartCount()
    }

    fun clearCart() {
        cartItems = emptyMap()
        updateCartCount()
    }

    fun showNotPhoneDialogEvent() {
        _onNotPhoneDialogEvent.value = Event(true)
    }

    fun hideNotPhoneDialogEvent() {
        _onNotPhoneDialogEvent.value = Event(false)
    }
}